// @flow
import * as React from 'react';
import {useHistory} from 'react-router-dom';
import styled from 'styled-components';
import ModalIndex, {type BaseProps, type Menu, type Action} from 'components/ModalIndex';
import {LayoutWrapper, useLayoutState} from 'components/Layout';
import {useLocalized, type LocalizedText} from 'components/Localized';
import {ButtonCloseWhite} from 'components/ButtonClose';
import {useSessionState, useSessionDispatch} from 'components/Session';
import {GuideLinePointLT} from '../GuideLinePoint';

export default function ModalIndexA(props: BaseProps): React.Element<any> {
  const history = useHistory();
  const localized = useLocalized();
  const sessionState = useSessionState();
  const sessionDispatch = useSessionDispatch();
  const [showGuide, setShowGuide] = React.useState(false);

  const handleMoveTo = React.useCallback(
    (url: string) => {
      history.push(`/driving-zone/course-a/${url}`);
      props.onClose();
    },
    [history, props]
  );

  const handleMoveToOther = React.useCallback(() => {
    history.push('/driving-zone/course-b');
  }, [history]);

  const titles: Array<LocalizedText> = React.useMemo(
    () => [localized.driving_a01_index_001, localized.driving_a01_index_001_sub],
    [localized]
  );
  const leftMenus: Array<Menu> = React.useMemo(
    () => [
      {
        localText: localized.driving_a01_index_002,
        onClick: () => {window.tagManager.indexPopCollectGTItemsLinkClick();handleMoveTo('play?guide=2');},
        active: true,
      },
      {
        localText: localized.driving_a01_index_003,
        onClick: () => {window.tagManager.indexPopActivateGTModeLinkClick();handleMoveTo('gtmode-guide');},
        active: !history.location.pathname.includes('play'),
      },
      {
        localText: localized.driving_a01_index_004,
        onClick: () => {window.tagManager.indexPopAcceltaionOfGTLinkClick();handleMoveTo('acceleration');},
        active:
          !history.location.pathname.includes('play') &&
          !history.location.pathname.includes('gtmode-guide'),
      },
    ],
    [localized, history.location.pathname, handleMoveTo]
  );

  const rightMenu: Action = React.useMemo(() => {
    return {
      header: localized.driving_a01_index_001_title,
      localTexts: [localized.driving_a01_index_005, localized.driving_a01_index_005_cv],
      onClick: handleMoveToOther,
      titles: [localized.driving_a01_index_005_sub, localized.driving_a01_index_005_sub_cv, localized.driving_a01_index_008],
      buttons: [localized.driving_a01_index_012, localized.driving_a01_index_013],
    };
  }, [localized, handleMoveToOther]);

  const handleGuideClose = React.useCallback(() => {
    setShowGuide(false);
    sessionDispatch({type: 'SKIP_GUIDE', data: 'guide-modalindex-a'});
  }, [sessionDispatch]);

  React.useEffect(() => {
    setShowGuide(!sessionState.skipGuide?.includes('guide-modalindex-a'));
    //eslint-disable-next-line
  }, []);

  return <React.Fragment>
    {props.open && showGuide && <GuideModalIndex localized={localized} onNext={handleGuideClose} />}
    <ModalIndex {...props} titles={titles} leftMenus={leftMenus} rightMenu={rightMenu} 

    rightMenuOpen={()=>{
      window.tagManager.indexPopAnotherThemeGTLine();
    }}

    rightMenuYes={()=>{
      window.tagManager.indexPopSwitchThemeOKLinkClick();
    }}

    rightMenuNo={()=>{
      window.tagManager.indexPopSwitchThemeNOLinkClick();
    }}

     />
    </React.Fragment>;
}

type PropsGuideModalIndex = {
  localized: Object,
  onNext: () => void,
}

function GuideModalIndex(props: PropsGuideModalIndex): React.Element<any> {
  const layoutState = useLayoutState();
  const [update, setUpdate] = React.useState(0)
  const point1 = React.useMemo(() => {
    const target = window.document.getElementById("modal-index-play3");
    return target?.getBoundingClientRect() ?? {};
    // eslint-disable-next-line
  }, [update])
  const point2 = React.useMemo(() => {
    const target = window.document.getElementById("modal-index-gt-line");
    return target?.getBoundingClientRect() ?? {};
    // eslint-disable-next-line
  }, [update])
  const point3 = React.useMemo(() => {
    const target = window.document.getElementById("modal-index-color");
    return target?.getBoundingClientRect() ?? {};
    // eslint-disable-next-line
  }, [update])

  React.useEffect(() => {
    if (point1.x === undefined) {
      setTimeout(() => setUpdate(update+1), 100)
    }
  }, [update, point1])

  React.useEffect(() => {
    setUpdate(update + 1);
    //eslint-disable-next-line
  }, [layoutState.width, layoutState.height])

  return (
  <GuideWrapper2>
    <GuideBack />
    <ButtonCloseWhite onClose={props.onNext} />
    <LayoutWrapper>
      <GuideLinePointLT title={props.localized.driving_a00_guide_006} datarect={point1} />
      <GuideLinePointLT title={props.localized.driving_a00_guide_007} datarect={point2} datax={layoutState.mobile ? 0.45 : 0.81} datay={0.23} />
      <GuideLinePointLT title={props.localized.driving_a00_guide_008} datarect={point3} datax={layoutState.mobile ? 0.04 : 0.06} />
    </LayoutWrapper>
  </GuideWrapper2>
  );
}

const GuideWrapper2 = styled.div`
  z-index: 1001;

  width: 100%;
  height: 100%;
  
  position: absolute;
  left: 0px;
  top: 0px;

  pointer-events: auto;
`;

const GuideBack = styled(LayoutWrapper)`
  background-color: rgba(0, 0, 0, 0.6);
`;
